import { defaultTwitterCardMeta } from '~/constants/seo';
import { normalizeString, getUrlFromStaticDNS } from '~~/app/utils';

type GrammarGender = 'male' | 'female' | 'neutral';

const grammarPrefix: Record<GrammarGender, string> = {
	male: 'no',
	female: 'na',
	neutral: 'em'
};

export function getRegionMetadata(
	region: string,
	city: string,
	grammar: { gender: GrammarGender }
) {
	const title = `${region}, ${city} | Guia do Bairro | PilarHomes`;

	const prefix = grammarPrefix[grammar.gender];
	const description = `Como é morar e o que fazer ${prefix} ${region}, bairro que combina vida pessoal e profissional, em umas das regiões mais privilegiadas de ${city}.`;

	const keywords = [region, city].join(', ');

	const imageBaseURL = '/images/social/openGraph/regions/';
	const normalizedRegion = normalizeString(region, [' ']).replaceAll(' ', '_');
	const imageURL = getUrlFromStaticDNS(
		`${imageBaseURL}${normalizedRegion}.jpg`
	);

	return {
		title: title,
		description: description,
		keywords: keywords,
		ogTitle: title,
		ogDescription: description,
		ogImage: imageURL,
		twitterCard: defaultTwitterCardMeta,
		twitterTitle: title,
		twitterDescription: description,
		twitterImage: imageURL
	};
}
